/*! tailwindcss v4.3.3 | MIT License | https://tailwindcss.com */
@layer properties;
.li {
  list-style-type: none;
  cursor: pointer;
  @media (width >= 40rem) {
    white-space: nowrap;
  }
  padding-inline: 1.5em;
  padding-block: 0.75em;
}
.li:hover {
  background-color: var(--color-gray-100, #f5f5f5);
  border-radius: var(--radius-sm, 0.25rem);
}
.item {
  margin-inline: calc(var(--spacing, 0.25rem) * 2);
}
.selected {
  border-color: var(--color-primary-500);
  background-color: var(--color-primary-100);
  --tw-border-style: solid;
  border-style: solid;
  border-style: var(--tw-border-style);
  border-width: 1px;
  border-radius: var(--radius-sm, 0.25rem);
}
.disabled {
  opacity: 30%;
  cursor: not-allowed;
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-border-style: solid;
    }
  }
}
